import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=16c368e6&scoped=true&lang=pug&"
import script from "./GlobalAlert.vue?vue&type=script&lang=ts&"
export * from "./GlobalAlert.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalAlert.vue?vue&type=style&index=0&id=16c368e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c368e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VFlex,VLayout})
